import {
    combineEpics,
    Epic,
    EpicMiddleware,
    createEpicMiddleware,
  } from 'redux-observable';
  import {Services, RootState} from '../types';
  import * as appActions from '../modules/app/store/actions';
  import * as authActions from '../modules/auth/store/actions';
  import * as dashboardActions from '../modules/admin/store/actions';
  import * as contractorDashboardActions from '../modules/contractors/store/actions';
  import * as userActivitiesActions from '../modules/user-activities/store/actions';
  import AuthEpics from '../modules/auth/store/epics';
  import AppEpics from '../modules/app/store/epics';
  import DashboardEpics from '../modules/admin/store/epics';
  import ContractorDashboardEpics from '../modules/contractors/store/epics';
  import UserActivitiesEpics from '../modules/user-activities/store/epics';

  import {ActionType} from 'typesafe-actions';
  
  interface EpicConfiguration {
    rootEpic: RootEpic;
    epicMiddleware: EpicMiddleware<Actions, Actions, RootState, Services>;
  }
  export type Actions = ActionType<typeof appActions> | ActionType<typeof authActions>
   | ActionType<typeof dashboardActions> | ActionType<typeof contractorDashboardActions> 
   | ActionType<typeof userActivitiesActions>;
  
  
  export type RootEpic = Epic<Actions, Actions, RootState, Services>;
  interface EpicConfiguration {
    rootEpic: RootEpic;
    epicMiddleware: EpicMiddleware<Actions, Actions, RootState, Services>;
  }
  
  export const configureEpic = (services: Services): EpicConfiguration => {
    const rootEpic = combineEpics(
      ...AuthEpics,
      ...AppEpics,
      ...DashboardEpics,
      ...ContractorDashboardEpics,
      ...UserActivitiesEpics,
    );
    const epicMiddleware = createEpicMiddleware<
      Actions,
      Actions,
      RootState,
      Services
    >({
      dependencies: services,
    });
  
    return {
      rootEpic,
      epicMiddleware,
    };
  };
  